import { useQuery } from '@apollo/client';
// Api
import { ESTIMATE_STREAM_PRICE } from 'api/streams/queries';
// Types
import {
  EstimateStreamPrice,
  EstimateStreamPriceVariables,
} from 'api/streams/types/EstimateStreamPrice';

/**
 * What the organizer keeps from one PPV sale after the platform fee.
 * Returns 0 for free streams and while the price is empty or invalid.
 */
export const useEstimatedStreamProfit = (
  price: string | number | null | undefined,
  isFree?: boolean
): number => {
  const finalPrice = Number(price);
  const skip = Boolean(isFree) || !(finalPrice > 0);

  const { data } = useQuery<EstimateStreamPrice, EstimateStreamPriceVariables>(
    ESTIMATE_STREAM_PRICE,
    {
      variables: { input: { finalPrice } },
      skip,
    }
  );

  if (skip) {
    return 0;
  }

  return data?.estimateStreamPrice.profit ?? 0;
};
